import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import { ToolNameValue } from 'app/store/pagesToolbar/pagesToolbar.types';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectFocusModeEnabled } from 'app/store/AppUI/AppUI.selectors';
import { selectNewDesignEnabled, selectFiltersSidebarOpen } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { ToggleButton, Toolbar, Tooltip } from '@mui/material';
// Icons
import {
  Tune as TuneIcon,
  FilterListOutlined as FilterListOutlinedIcon
} from '@mui/icons-material';
// Components
import FocusModeButton from 'app/components/FocusModeButton';
// Utils
import { usePagesToolbarContext } from './utils/usePagesToolbarContext'

type Props = {
  children?: ReactNode;
};

const BarContainer = ({ children }:Props) => {
  const { t } = useTranslation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const focusModeEnabled = useAppSelector(selectFocusModeEnabled);
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  const filtersSidebarOpen = useAppSelector(selectFiltersSidebarOpen);

  const { tools, hiddenTools } = usePagesToolbarContext();

  const handleClick = () => {
    dispatch(PagesToolbarActions.toggleFiltersSidebarOpen());
  }

  const barTools = newDesignEnabled ? tools.newDesignBar : tools.bar;

  return (
    <Toolbar sx={{ gap: 2 }}>
      {children || null}
      {Object.keys(barTools).map((key) => {
        const Tool = barTools[key as ToolNameValue];
        if ( newDesignEnabled ) return <Tool key={key} />;
        const isHidden = hiddenTools.includes(key as ToolNameValue);
        if ( isHidden ) return null;
        return <Tool key={key} />
      })}
      <FocusModeButton />
      {!focusModeEnabled ? (
        <Tooltip title={newDesignEnabled ? t('labels.filters') : t('labels.additionalTools')}>
          <ToggleButton
            value="open"
            selected={filtersSidebarOpen}
            onClick={handleClick}
            color="primary"
            size="small"
          >{newDesignEnabled ? <FilterListOutlinedIcon /> : <TuneIcon />}</ToggleButton>
        </Tooltip>
      ) : null}
    </Toolbar>
  )
}

export default BarContainer;
